import { render, staticRenderFns } from "./SchoolJobSeekersAppraisal.vue?vue&type=template&id=0ff3eacd&scoped=true&"
import script from "./SchoolJobSeekersAppraisal.vue?vue&type=script&lang=js&"
export * from "./SchoolJobSeekersAppraisal.vue?vue&type=script&lang=js&"
import style0 from "./SchoolJobSeekersAppraisal.vue?vue&type=style&index=0&id=0ff3eacd&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ff3eacd",
  null
  
)

export default component.exports